import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Images from 'assets/images/imageData';
import Loader from 'components/sales/Loader/loader';
import  './layout.css'
const Layout = ({
  children,
  title,
  isGoback,
  history,
  className,
  Buttons = null,
  isLoading = false,
  status,
  linkFlag = false,
  linkUrl = '#',
  pagination = true,
  searchOption=false,
}) => {
  return (
    <Fragment>

      <div className={`content-wrapper ${className}`}>
      
       
        <div className="layout-header">
      

          <div><h4 className="back-btn-sizes">
            {isGoback ? (
              <Link to={linkUrl} onClick={() => !linkFlag && history.goBack()}>
                <img src={Images?.BackArrowBlack} alt="" />
                <span style={{'font-size': '20px'}}>{title}</span>
              </Link>
            ) : (
              <span style={{'font-size': '20px'}}>{title}</span>
            )}
        </h4></div>
          <div className="btn-group">
            <div className="d-none d-md-inline-block">
              {Buttons && Buttons()}
              </div>
           
          </div>
        </div>


        <div
          className={
            pagination
              ? 'panel scrollbar-styling pagination pagination1 pr-pagination'
              : 'panel scrollbar-styling'
          }
          
        >
          {children}
        </div>
        <div className="btn-group">
          <div className="d-md-none d-block pr-btn xs-fullwidth">
          <div className="pr-btn poc-btn">
          <b className="Mf-btn">
            {Buttons && Buttons()}
          </b>
            </div>
        </div>
        </div>
      </div>
     
      <Loader isLoading={isLoading} />
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isGoback: PropTypes.bool,
  history: PropTypes.object,
  className: PropTypes.string,
  Buttons: PropTypes.func,
};

export default withRouter(Layout);
